<template>
    <div>
        <div class="table-layout">
            <el-table :height="500+'px'" :data="callBidDocNoticeList" border style="width: 100%">
                <el-table-column prop="title" label="发布名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="publishTime" label="发布时间" width="200"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
                <el-table-column label="操作" width="250">
                    <template slot-scope="scope">
                        <a class="swb-btn-link" @click="lookNotice(scope.row.id)">查看</a>
                        <a class="swb-btn-link" v-if="!scope.row.published" @click="editNotice(scope.row.id)">编辑</a>
                        <a class="swb-btn-link" v-if="!scope.row.published" @click="delNotice(scope.row.id)">删除</a>
                        <a class="swb-btn-link" v-if="!scope.row.published && callBidDocInfo.auditState != 0" @click="publishedNotice(scope.row)">发布</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import callBidApi from '../../api/callBid'

    import SwbCallBidNoticeSave from './CallBidNoticeSave';
    Vue.regist(SwbCallBidNoticeSave);

    import SwbCallBidNoticePublish from './CallBidNoticePublish';
    Vue.regist(SwbCallBidNoticePublish);

    export default {
        name: 'swb-call-bid-notice-list',
        desc: '招标公告列表',
        props: ['docId', 'state'],
        data: function () {
            return {
                callBidDocNoticeList: [],
                callBidDocInfo: {}
            }
        },
        created: function () {
            this.getCallBidNoticeList();
            this.getCallBidDoc();
        },
        methods: {
            getCallBidNoticeList: function () {
                let self = this;
                let paramsData = {};
                paramsData.docId = self.docId;
                let lastMsgBoxDlg = MsgBox.loading();
                callBidApi.getCallBidNoticeListByDocId(paramsData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type === "info") {
                        let data = result.data;
                        self.callBidDocNoticeList = data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getCallBidDoc: function () {
                let self = this;
                let postData = {};
                postData.id = self.docId;
                let lastMsgBoxDlg = MsgBox.loading();
                callBidApi.getCallBidDocInfo(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == 'info') {
                        self.callBidDocInfo = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            editNotice: function (id) {
                let self = this;
                let paramsData = {};
                paramsData.id = id;
                let lastMsgBoxDlg = MsgBox.loading();
                callBidApi.getCallBidNotice(paramsData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type === "info") {
                        let callBidDocNotice = result.data;
                        if(callBidDocNotice.published != true) {
                            self.getCallBidNoticeByDocIdAndPublished(self.docId, true);
                        } else {
                            MsgBox.warning("此公告已经发布不能修改");
                            return;
                        }
                    }
                });
            },

            delNotice: function (id) {
                let self = this;
                this.$confirm('是否确定删除 ?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = id;
                    let lastMsgBoxDlg = MsgBox.loading();
                    callBidApi.deleteCallBidNotice(postData, function (result) {
                        lastMsgBoxDlg.close();
                        if(result.type == 'info') {
                            self.getCallBidNoticeList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },

            publishedNotice: function (data) {
                let self = this;
                Vue.$showDialog({
                    title: '发布 - 公告',
                    showCloseBtn: true,
                    width: 700,
                    height: 700,
                    okText: "发布",
                    template: '<div>' +
                    '<swb-call-bid-notice-publish :docId="docId" :state="state" ref="swb_call_bid_notice_publish"></swb-call-bid-notice-publish>' +
                    '</div>',
                    data: {
                        docId: null,
                        state: self.state,
                    },
                    okClicked: function () {
                        let selfDef = this;
                        let result = selfDef.$refs.swb_call_bid_notice_publish.getDlgResult() || {};
                        if(result.type == "info") {
                            MsgBox.success("成功")
                            selfDef.pubishedCallBidNotice(result.data)
                        } else {
                            MsgBox.warning(result.message);
                            return false;
                        }
                    },
                    methods: {
                        pubishedCallBidNotice: function (postData) {
                            this.$confirm('是否确定发布 ?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(function () {
                                postData = postData;
                                postData.id = data.id;
                                callBidApi.publishCallBidNotice(postData, function (result) {
                                    if(result.type == 'info') {
                                        self.getCallBidNoticeList();
                                    } else {
                                        MsgBox.warning(result.message);
                                    }
                                });
                            }).catch(function () {
                            });
                        }
                    },
                    lifecycle: {
                        created: function () {
                            this.docId = self.docId;
                        }
                    }
                });
            },

            getCallBidNoticeByDocIdAndPublished: function (docId, countBoolean) {
                let self = this;
                let postData = {};
                postData.docId = docId;
                postData.published = false;
                callBidApi.getCallBidNoticeByDocIdAndPublished(postData, function (result) {
                    if(result.type == 'info') {
                        let callBidNotice = result.data;
                        if(callBidNotice != null) {
                            let id = callBidNotice.id;
                            self.editCallBidNotic(id, docId, countBoolean)
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
            ,

            lookNotice: function (id) {
                let self = this;
                let paramsData = {};
                paramsData.id = id;
                callBidApi.getCallBidNotice(paramsData, function (result) {
                    if(result.type == "info") {
                        let callBidDocNotice = result.data;
                        Vue.$showDialog({
                            title: '查看 - 公告',
                            showCloseBtn: true,
                            width: 1200,
                            height: 900,
                            template: '<div>' +
                            '<swb-call-bid-notice-save :docId="docId" :content="content" :id="id" :add="add" ref="swb_call_bid_notice"></swb-call-bid-notice-save>' +
                            '</div>',
                            data: {
                                id: id,
                                docId: null,
                                add: null,
                                content: null,
                            },
                            okClicked: function () {
                            },
                            okVisible: false,
                            method: {},
                            lifecycle: {
                                created: function () {
                                    this.content = callBidDocNotice.content;
                                    this.docId = self.docId;
                                }
                            }

                        });
                    }

                })

            }
            ,

            editCallBidNotic: function (id, docId, add) {
                let self = this;
                Vue.$showDialog({
                    title: '编辑 - 公告',
                    showCloseBtn: true,
                    width: 1200,
                    height: 900,
                    template: '<div>' +
                    '<swb-call-bid-notice-save :add="add" :docId="docId" :id="id" :state="state" ref="swb_call_bid_notice"></swb-call-bid-notice-save>' +
                    '</div>',
                    data: {
                        docId: docId,
                        id: id,
                        add: add,
                        state: self.state
                    },
                    okText: '保存',
                    okClicked: function () {
                        let result = this.$refs.swb_call_bid_notice.getDlgResult() || {};
                        if(result.type == "info") {
                            let postData = {};
                            postData = result.data;
                            postData.published = false;
                            callBidApi.saveCallBidNotice(postData, function (result) {
                                if(result.type == "info") {
                                    MsgBox.success("保存成功");
                                    self.getCallBidNoticeList();
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                            return false;
                        } else {
                            MsgBox.warning("请添加必须的信息");
                            return false;
                        }
                    },
                    method: {},
                    lifecycle: {}
                });
            }
            ,

        },
    }

</script>



// WEBPACK FOOTER //
// src/compo/callbid/CallBidNoticeList.vue